import { scrollToId } from "../landing/shared";

export default function ReplayStickyCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#001736]/80 backdrop-blur-xl border-t border-white/10 p-3" data-testid="replay-mobile-sticky-cta">
      <button
        type="button"
        onClick={() => scrollToId("apply")}
        className="cta-btn w-full"
        data-testid="replay-mobile-sticky-cta-button"
      >
        ✓ START MY APPLICATION
      </button>
    </div>
  );
}
